<template>
    <div class="body-wrap">
        <!--top navigation start-->
        <!-- <nav class="navbar navbar-light">
            <button class="navbar-toggler custom-toggler collapsed" type="button" data-toggle="collapse" data-target="#navbarsExample01" aria-controls="navbarsExample01" aria-expanded="false" aria-label="Toggle navigation">
                <span class="navbar-toggler-icon"></span>
            </button>
            <a class="navbar-brand" href="#"><img src="../assets/images/newui/logo_4x.png" alt="Printed Agent" class="img-fluid" /></a>
        </nav> -->
        <!--top navigation end-->
        <main role="main">
            <div class="container">
                <h1 class="home-heading">Our full site is<br /><em>coming soon.</em></h1>
                <div class="home-btn-panel">
                    <div>
                        <a class="landing-pa-btn-primary-outline"   @click="routeToAgent">Create an Agent account</a></div>
                    <div class="mt-3"><a class="landing-pa-btn-primary-outline"  @click="routeToTeam">Create a Team account</a></div>
                    <div class="mt-3"><a href="https://apps.worbix.com/" class="landing-pa-btn-primary">Login</a></div>
                </div>
                <!-- <div class="realtor-logo">
                    <span class="logo-circle logo-one">
                        <img alt="" src="../assets/images/logo-sothebys.png" class="img-fluid"/>
                    </span>
                    <span class="logo-circle logo-two">
                        <img alt="" src="../assets/images/logo-cb-vertical.png" class="img-fluid" />
                    </span>
                    <span class="logo-circle logo-three">
                        <img alt="" src="../assets/images/logo-drg.png" class="img-fluid" />
                    </span>
                </div>
                <div class="realtor-logo-heading">
                    Realtor Logos
                </div> -->
            </div>
        </main>
    </div>

</template>
<script>

export default {
    name: 'Landing',
    components: {
    },
    mounted() {

    },
    methods:{
        routeToAgent(){
            this.$router.push('/register');
        },
        routeToTeam(){
            this.$router.push('/registerTeam');
        }
    }
}
</script>
<style lang="scss">
.body-wrap{
    background-image: url(../assets/images/landing-bg.jpg);
    background-repeat: no-repeat;
    background-attachment: fixed;
    background-position: center -50px;
    height: 100%;
    min-height: 84vh;
}
a.landing-pa-btn-primary-outline{
    cursor: pointer;
    color: #5e9dbc;
    width: 300px;
    &:hover{
        color: #fff;
    }
}
a.landing-pa-btn-primary{
    width: 300px;
}
</style>
